var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.408 7.32h.711l.908 12.873c.015.213.193.379.407.379h10.739a.408.408 0 0 0 .407-.38l.908-12.872h.711a.408.408 0 0 0 .408-.408V4.847c0-.782-.637-1.42-1.42-1.42h-2.982v-2.02A.408.408 0 0 0 11.797 1H5.81a.408.408 0 0 0-.408.408v2.02H2.42c-.783 0-1.42.637-1.42 1.42v2.064c0 .225.183.408.408.408zm12.385 12.436H3.814L2.937 7.32H14.67l-.877 12.436zM6.218 1.816h5.171v1.612H6.218V1.815zM1.815 4.846c0-.333.271-.604.605-.604H15.187c.333 0 .604.271.604.604v1.658H1.815V4.847z",
    stroke: "#1C1B1A",
    strokeWidth: 0.2,
    fill: "#1C1B1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.117 17.547a.408.408 0 0 0 .408-.408V9.937a.408.408 0 0 0-.815 0v7.202c0 .225.182.408.407.408zM8.803 17.547a.408.408 0 0 0 .408-.408V9.937a.408.408 0 0 0-.815 0v7.202c0 .225.182.408.407.408zM11.49 17.547a.408.408 0 0 0 .408-.408V9.937a.408.408 0 0 0-.816 0v7.202c0 .225.183.408.408.408z",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.565656993dffbea5756f69200014d434.svg";
export { ForwardRef as ReactComponent };